import styled from 'styled-components';
import { White } from '../../../colors';
import { Row, GridContainer, SCREEN_SIZE } from '../../grid';
export const RowHeader = styled(Row) `
    background-color: ${White.normal};
    height: 90px;
    overflow: hidden;

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        height: auto;
    }
`;
export const ChildrenContainer = styled('div') `
    margin-bottom: 120px;

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        margin-bottom: 145px;
    }
`;
export const HeaderContainer = styled(GridContainer) `
    width: 100%;
    background-color: ${White.normal};
    box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.1);
`;
export const ActionContainer = styled('div') `
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: ${White.normal};
    box-shadow: 0px 4px 5px 4px rgba(0,0,0,0.1);
`;
//# sourceMappingURL=PrivacyPolicyLayout.Styled.js.map